import { AppointmentBooking } from './der-tailormade-appointment-booking.component';

export * from './der-tailormade-appointment-booking.component';
export default AppointmentBooking;

AppointmentBooking.define('der-tailormade-appointment-booking');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-appointment-booking': AppointmentBooking;
    }
}
